import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CustomRadioButton from '../../../../shared-components/custom-radio-button/CustomRadioButton';
import TablesToggle from '../../../../shared-components/tables-toggle/TablesToggle';

import RequestApprovedAccount from './account/RequestApproved';
import RequestPendingAccount from './account/RequestPending';
import RequestRejectedAccount from './account/RequestRejected';
import RequestApprovedStation from './station/RequestApproved';
import RequestPendingStation from './station/RequestPending';
import RequestRejectedStation from './station/RequestRejected';

/**
 * Request Pages
 * @returns {any} - Request List component
 */
function RequestList() {
  const { t } = useTranslation('penaltyManagement');
  const [currentPage, setCurrentPage] = useState<'account' | 'station'>('account');

  /**
   * Get tabs for request pages
   * @param {any} type - Request type (account or station)
   * @returns {any} - Tabs for request pages
   */
  const getTabs = (type: 'account' | 'station') => {
    if (type === 'account') {
      return [
        { label: t('approved'), content: <RequestApprovedAccount /> },
        { label: t('pending'), content: <RequestPendingAccount /> },
        { label: t('rejected'), content: <RequestRejectedAccount /> },
      ];
    }

    return [
      { label: t('approved'), content: <RequestApprovedStation /> },
      { label: t('pending'), content: <RequestPendingStation /> },
      { label: t('rejected'), content: <RequestRejectedStation /> },
    ];
  };

  /**
   * Handle change page
   * @param {any} value - Request type (account or station)
   */
  const handleChangePage = (value: 'account' | 'station') => {
    setCurrentPage(value);
  };

  /**
   * Render radio buttons for request pages
   * @returns {any} - Radio buttons for request pages
   */
  const renderRadioButtons = () => {
    return (
      <div className="radio-buttons">
        <CustomRadioButton
          selected={currentPage === 'account'}
          label={t('account')}
          value="account"
          name="account"
          onChangeFunc={(value) => handleChangePage(value as 'account')}
        />
        <CustomRadioButton
          selected={currentPage === 'station'}
          label={t('station')}
          value="station"
          name="station"
          onChangeFunc={(value) => handleChangePage(value as 'station')}
        />
      </div>
    );
  };
  return (
    <div className="request-list">
      <TablesToggle tabs={getTabs(currentPage)} rightContent={renderRadioButtons()} />
    </div>
  );
}

export default RequestList;
